"use client";

import { useEffect } from "react";

/**
 * Registers the Serwist-built service worker at /sw.js.
 *
 * `@serwist/turbopack` serves the SW from a Route Handler but does NOT
 * auto-register it (unlike `@serwist/next`'s webpack mode). We register
 * manually here. Only runs in production to avoid stale SWs lingering
 * during local dev — Turbopack HMR + a cached SW makes for surprising
 * dev-only bugs.
 */
export function ServiceWorkerProvider() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (typeof navigator === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
      // Registration failures shouldn't break the app — log for diagnostics.
      console.warn("Service worker registration failed", err);
    });
  }, []);

  return null;
}
